export const rollover = {
  'nav.newYear': 'السنة الجديدة',
  'settings.years.rollover': 'الانتقال إلى سنة جديدة',

  'rollover.title': 'الانتقال إلى سنة دراسية جديدة',
  'rollover.subtitle': 'من {from} إلى {to}',
  'rollover.subtitleNoNext': 'من {from}: جهّز السنة التالية أولاً',
  'rollover.fromYear': 'من سنة',

  'rollover.prepare.title': 'جهّز السنة الجديدة',
  'rollover.prepare.subtitleNew': 'أنشئ السنة التالية وانسخ إليها ما في {from}.',
  'rollover.prepare.subtitleExisting': 'النسخ يضيف إلى {to} ما ينقصها فقط، ولا يغيّر ما فيها.',
  'rollover.prepare.name': 'اسم السنة',
  'rollover.prepare.start': 'تبدأ',
  'rollover.prepare.end': 'تنتهي',
  'rollover.prepare.copyFrom': 'انسخ من {from}',
  'rollover.prepare.create': 'أنشئ السنة الجديدة',
  'rollover.prepare.copy': 'انسخ الناقص',
  'rollover.prepare.done': 'جُهّزت {name}.',
  'rollover.prepare.nothing': 'لم ينقص شيء: السنة الجديدة فيها كل ذلك.',
  'rollover.counts': 'هذه السنة {from}، والجديدة {to}',
  'rollover.countFrom': 'في هذه السنة: {n}',

  'rollover.copy.classes': 'الشعب',
  'rollover.copy.classesHint': 'الشعب نفسها في كل صف (الأول أ، الأول ب…)',
  'rollover.copy.feeItems': 'قائمة الرسوم',
  'rollover.copy.feeItemsHint': 'بالمبالغ نفسها، وتعدّلها بعد ذلك من صفحة الرسوم',
  'rollover.copy.gradingPlans': 'خطط الدرجات',
  'rollover.copy.terms': 'الفصول الدراسية',
  'rollover.copy.termsHint': 'بالتواريخ نفسها بعد سنة',
  'rollover.copy.teaching': 'توزيع المواد والجدول الأسبوعي',
  'rollover.copy.teachingHint': 'للشعب التي ليس لها توزيع ولا جدول بعد؛ من غادر من المدرّسين لا يُنسخ',

  'rollover.decide.title': 'قرارات الطلاب',
  'rollover.decide.subtitle': 'مقترحة من نتيجة كل طالب، ولك أن تغيّرها. لا يتغيّر شيء حتى تضغط «رحّل المحدَّدين».',
  'rollover.filter.todo': 'بانتظار القرار',
  'rollover.filter.done': 'رُحِّلوا',
  'rollover.filter.all': 'الكل',
  'rollover.filter.label': 'عرض الطلاب',
  'rollover.filter.class': 'الشعبة',
  'rollover.filter.allClasses': 'كل الشعب',
  'rollover.col.select': 'تحديد',
  'rollover.col.student': 'الطالب',
  'rollover.col.class': 'الشعبة الآن',
  'rollover.col.result': 'النتيجة',
  'rollover.col.decision': 'القرار',
  'rollover.col.newClass': 'الشعبة الجديدة',
  'rollover.col.balance': 'الرصيد',
  'rollover.decision.PROMOTE': 'ينتقل',
  'rollover.decision.REPEAT': 'يعيد السنة',
  'rollover.decision.GRADUATE': 'يتخرّج',
  'rollover.decision.LEAVE': 'يغادر المدرسة',
  'rollover.choose': 'اختر…',
  'rollover.waiting.SECOND_ROUND': 'بانتظار الدور الثاني',
  'rollover.waiting.NO_RESULT': 'لا نتيجة',
  'rollover.noClass': 'لا شعبة لصف {grade} في السنة الجديدة',
  'rollover.inNewYear': 'مسجَّل في {class}',
  'rollover.moved.carried': 'رصيد عليه مُرحَّل {amount}',
  'rollover.moved.credit': 'رصيد له مُرحَّل {amount}',
  'rollover.selectReady': 'حدّد الجاهزين',
  'rollover.clearSelection': 'ألغِ التحديد',
  'rollover.selected': 'المحدَّدون: {n}',
  'rollover.carry': 'انقل الأرصدة إلى السنة الجديدة',
  'rollover.carryHint': 'ما بقي على الطالب (أو له) يُغلق في {from} ويُفتح به حسابه في {to}',
  'rollover.apply': 'رحّل المحدَّدين',
  'rollover.confirm.title': 'ترحيل {n}؟',
  'rollover.confirm.PROMOTE': 'ينتقل {n}',
  'rollover.confirm.REPEAT': 'يعيد السنة {n}',
  'rollover.confirm.GRADUATE': 'يتخرّج {n}',
  'rollover.confirm.LEAVE': 'يغادر {n}',
  'rollover.confirm.join': '، و',
  'rollover.confirm.fees': 'تُحسب رسوم الصف الجديد على من ينتقل أو يعيد.',
  'rollover.confirm.carry': 'وتنتقل أرصدتهم إلى {to}.',
  'rollover.confirm.undo': 'ويمكن التراجع عن أي طالب ما دام ليس له شيء في السنة الجديدة.',
  'rollover.applied': 'رُحِّل {n}.',
  'rollover.problems': 'لم يُرحَّل أحد: راجع الطلاب المعلَّمين بالأحمر.',
  'rollover.problem.NOT_IN_YEAR': 'ليس في هذه السنة',
  'rollover.problem.ALREADY_MOVED': 'رُحِّل من قبل',
  'rollover.problem.ALREADY_IN_NEW_YEAR': 'مسجَّل في السنة الجديدة',
  'rollover.problem.CLASS_REQUIRED': 'اختر الشعبة',
  'rollover.problem.CLASS_NOT_IN_NEW_YEAR': 'الشعبة ليست من السنة الجديدة',
  'rollover.problem.NOT_A_HIGHER_GRADE': 'اختر شعبة من صف أعلى',
  'rollover.problem.NOT_THE_SAME_GRADE': 'اختر شعبة من الصف نفسه',
  'rollover.problem.NO_CLASS_WHEN_LEAVING': 'لا شعبة لمن يتخرّج أو يغادر',
  'rollover.undo': 'تراجع',
  'rollover.undo.title': 'التراجع عن ترحيل {name}؟',
  'rollover.undo.body': 'يُحذف تسجيله في السنة الجديدة، وتُلغى رسومها والرصيد المرحَّل، ويعود كما كان في {from}.',
  'rollover.undo.done': 'تمّ التراجع.',
  'rollover.undo.blocked': 'لا يمكن التراجع: للطالب في السنة الجديدة دفعات أو درجات أو حضور. انقله من صفحته بدلاً من ذلك.',
  'rollover.undo.movedSince': 'لا يمكن التراجع: نُقل الطالب إلى شعبة أخرى بعد الترحيل.',
  'rollover.empty': 'لا طلاب في هذه السنة.',
  'rollover.emptyFilter': 'لا طلاب هنا.',

  'rollover.appliedDeferred': 'رُحِّل {n}. تنتقل الأرصدة ويخرج المتخرّجون والمغادرون حين تصبح {to} السنة الحالية.',
  'rollover.tooMany': 'رحّل {n} طالب أو أقل في كل مرة: اختر شعبة من القائمة.',
  'rollover.moved.carryLater': 'ينتقل الرصيد حين تصبح {to} السنة الحالية',
  'rollover.moved.departsLater': 'يخرج حين تصبح {to} السنة الحالية',
  'rollover.confirm.deferred':
    'وتبقى السنة الجارية كما هي حتى الخطوة الثالثة: الأرصدة تنتقل والمتخرّجون والمغادرون يخرجون حين تجعل {to} السنة الحالية.',
  'rollover.finish.title': 'أكمِل الانتقال',
  'rollover.finish.body':
    '{to} هي السنة الحالية الآن. بقي أن يخرج المتخرّجون والمغادرون ({departures})، وأن تنتقل أرصدة المرحَّلين ({balances}).',
  'rollover.finish.button': 'أكمِل الانتقال',
  'rollover.finish.done': 'خرج {departed}، وانتقلت أرصدة {carried}.',
  'rollover.switch.secondRound':
    '{n} بانتظار الدور الثاني. أدخِل درجاته قبل أن تجعل {to} السنة الحالية، فصفحة الدرجات تعرض السنة الحالية فقط. ويمكنك بعد ذلك أن تقرّر لهم هنا بنفسك.',
  'rollover.switch.title': 'اجعلها السنة الحالية',
  'rollover.switch.body':
    'حين يبدأ العام، اجعل {to} السنة الحالية: تظهر شعبها في الحضور والجدول والدرجات، ويرى أولياء الأمور صفوف أبنائهم الجديدة.',
  'rollover.switch.pending': 'لم يُتّخذ قرار لـ {n} بعد؛ يبقون في {from}، ويمكن ترحيلهم لاحقاً من هذه الصفحة.',
  'rollover.switch.button': 'اجعل {to} السنة الحالية',
  'rollover.switch.confirm': 'تصبح {to} السنة الحالية في كل الشاشات وفي تطبيق أولياء الأمور.',
  'rollover.switch.done': '{to} هي السنة الحالية الآن.',
  'rollover.switch.already': '{to} هي السنة الحالية. ويمكنك ترحيل من بقي من {from} هنا.',
} as const;
